import React from "react";
import ContactWrapperArea from "./ContactWrapperArea";

function Contact() {
  return (
    <>
      <ContactWrapperArea />
    </>
  );
}

export default Contact;
